import React from "react";
import LoginCard from "../components/login/LoginCard";
import useTitle from "../hooks/useTitle";

const Login = () => {
  useTitle("Login")
  return (
    <div>
      <LoginCard />
    </div>
  );
};

export default Login;
